<template>
  <div> 

    <div>
      Pack Size:
      <label for="two">All:</label>
      <input type="radio" id="two" value="All" v-model="filterPackSize">
      &nbsp;&nbsp;
      <label for="one">25s:</label>
      <input type="radio" id="one" value="25" v-model="filterPackSize">
      &nbsp;&nbsp;
      <label for="two">20s:</label>
      <input type="radio" id="two" value="20" v-model="filterPackSize">
      &nbsp;&nbsp;
      🐞 Pack Size Filter currently only works if one of the above three filters are utilized.
    </div>
    
    <h4>Columns</h4>
    <div>
      Show Sales:<input type="checkbox" v-model="showSales">
      &nbsp; | &nbsp;
      Show Projected Sales:<input type="checkbox" v-model="showPojection">
      &nbsp; | &nbsp;
      Show Packs Sold:<input type="checkbox" v-model="showPacksSold">
      &nbsp; | &nbsp;
      Show SKUs:<input type="checkbox" v-model="showItemNums">
      
    </div>

    
    <h4>Pricing</h4>
    <div>
      <span style="font-weight: bold;">New Price:</span> 
      <input style="text-align: right;" size="6" v-model="price" >
      (AFTER tax GST {{gst | formatNumber('%')}} PST {{pst | formatNumber('%')}})
      &nbsp; 
      <button v-on:click="propigatePrice(price)">Propigate</button>  
      &nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button  v-on:click="propigatePrice(0.00)">Clear Pricing</button>  
      &nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      Manually Edit:<input type="checkbox" v-model="editPricesManually">
      <!-- &nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
      <!-- <a href="javascript:void(0);" v-on:click="propigatePrice()">Copy Current Price to Working Price</a>   -->
      <br>
      💡Note: This does not change the ⚡️live⚡️ price, it only changes a sandboxed price (stored in the DB)
      <br>
      ✅ Signifies when the current price matches the new price.
      <br>
      🛑 Signifies when the new price is zero.
    </div>

    <br>

    <div>
      <div v-if="!willPushToLocation && !willSchedulePushToLocation">
        
        <button v-on:click="willPushToLocation=!willPushToLocation">
          🔒 Push To Location
        </button>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <button v-on:click="willSchedulePushToLocation=!willSchedulePushToLocation">
          🔒 🕗 Schedule Push
        </button>
      </div>
      <div v-if="willSchedulePushToLocation">
        Not Implemented Yet, Coming Soon
        <button v-on:click="willSchedulePushToLocation=!willSchedulePushToLocation">
          Cancel
        </button>
      </div>
      <div v-if="willPushToLocation">
        
        🔓 Select Location: <LocationSelector v-model="pushLocation" />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button :disabled="pushLocation.length === 0" v-on:click="executePush()">
          ⚠️ Execute Push To Location
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button v-on:click="willPushToLocation=!willPushToLocation; pushLocation=''">
          Cancel
        </button>
      </div>
    </div>

    <table>
      <tr>
        <td v-for="location in $locations" :key="location" valign="top">
          <h4>{{location}}</h4>
          <table>
            <tr>
              <th>Dist</th><th>Name</th><th>Price</th><th>New Price</th>
              <th v-if="showPacksSold">Packs</th>
              <th v-if="showSales">Sales</th>
              <th v-if="showPojection">Projection</th>
              <th v-if="showPojection">Diff</th>
              <th v-if="showItemNums">Pack</th>
              <th v-if="showItemNums">Carton</th>
              <th v-if="showItemNums">Double Pack</th>
            </tr>
            <tbody v-if="filteredData.RCGB.topCigSales.length > 0">
              <tr v-for="d in filteredData[location].topCigSales" :key="d.ItemNum">
                <td>{{d.Distributor}}</td>
                <td>{{d.ItemName}}</td>
                <td align="right">
                  <span v-if="priceAfterTax(d.price)===roundedPrice(d.JSON.price)">✅</span>
                  {{(d.price + (d.price * pst) + (d.price * gst)) | formatNumber}}
                </td>
                <td align="right" v-if="!editPricesManually">
                  <span v-if="!(parseInt(d.JSON.price) > 0)">🛑</span>
                  {{d.JSON.price | formatStyle}}
                </td>
                <td align="right" v-if="editPricesManually">
                  <span v-if="!(parseInt(d.JSON.price) > 0)">🛑</span>
                  <input style="text-align: right;" size="6" v-model="d.JSON.price" v-on:change="saveEdit(location, d, d.JSON.price)">
                  <!-- <a href="javascript:void(0);" v-on:click="saveEdit(location, d)">save</a>   -->
                </td>
                
                <td align="right" v-if="showPacksSold">{{d.count | formatNumber('0')}}</td>
                <td align="right" v-if="showSales">{{d.count * (d.price + (d.price * pst) + (d.price * gst)) | formatNumber}}</td>
                <td align="right" v-if="showPojection">{{d.count * d.JSON.price | formatNumber}}</td>
                <td align="right" v-if="showPojection">{{(d.count * d.JSON.price) - (d.count * (d.price + (d.price * pst) + (d.price * gst))) | formatNumber}}</td>
                
                <td v-if="showItemNums">{{d.ItemNum}}</td>
                <td v-if="showItemNums">{{d.carton_ItemNum}}</td>
                <td v-if="showItemNums">{{d.double_pack_ItemNum}}</td>
                
              </tr>
              <!-- <tr>
                <td></td>
                <td align="right" style="font-weight:bold;">Total</td>
                <td style="font-weight:bold;">{{total[location].topCigSales.count}}pk</td>
              </tr> -->
            </tbody>

            <!-- Placeholder for empty data -->
            <tbody v-else>
              <tr v-for="index in qualifier.top" :key="index">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>-</td>
              </tr>
            </tbody>
          </table> 
        </td>
      </tr>
    </table> 
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'TopCigSalesTable',
  props : ['value', 'timestamps', 'qualifier'],
  data () { return {
      categories: [],
      taxes:[],
      price: 0,
      gst: 0.05,
      pst: 0.06,
      pushLocation: "",
      willPushToLocation: false,
      willSchedulePushToLocation: false,
      filterPackSize: "All",
      showItemNums:false,
      showSales:false,
      showPacksSold:false,
      showPojection:false,
      editPricesManually:false,
      data: {
        RCGB: {topCigSales:[]},
        RMGB: {topCigSales:[]},
        WGB : {topCigSales:[]},
      },
      // q: {
      //   top: 25,
      //   subtypes : ['CONF'],
      //   notSubtypes : ['Gas', 'CIGS', 'POP'],
      // }
    }
  },
  created : async function(){
    await this.loadCategories();
    await this.loadTaxes();
    this._loadData();
  },
  watch: {
    'timestamps.from' : 'loadData',
    'timestamps.to' : 'loadData',
    'qualifier.top' : 'loadData',
    'qualifier.subtypes' : 'loadData',
    'qualifier.notSubtypes' : 'loadData',
  },
  computed : {
    isLoading: function(){
      let result = false;
      this.$locations.forEach(location => {
        const l = this.data[location]
        result = result || l.topCigSales.isLoading;
      })
      return result;
    }
  },
  methods: {
    loadCategories: async function(){
      let r = await this.$axios.get(`/api/RMGB/categories`)
      this.categories = r.data;
    },
    loadTaxes: async function(){
      let r = await this.$axios.post(`/getStoreTaxes`, { location : 'RMGB' })
      this.taxes = r.data[0];
      this.gst = this.taxes.Tax1_Rate
      this.pst = this.taxes.Tax2_Rate
    },

    loadData: _.debounce(function(){
      this._loadData()
    }, 800),
    _loadData: function(){
      console.log('loading data')
      if(this.timestamps.from === undefined || this.timestamps.to === undefined){
        return;
      }
      
      //Strip timezone from ts 
      let from = moment(this.timestamps.from).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss");
      let to = moment(this.timestamps.to).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss");
      console.log('from to', from, to)
      
      this.$locations.forEach(location=>{
      // ['RMGB'].forEach(location=>{
        const getData = (endpoint, dataKey) => {
          this.data[location][dataKey] = [];
          this.data[location][dataKey].isLoading = true;
          const options = { location, from, to, ...this.qualifier}
          this.$axios.post(endpoint, options).then((r)=>{
            this.data[location][dataKey].isLoading = false;

            r.data.forEach(r=> r.JSON = r.JSON === null ? {} : JSON.parse(r.JSON));

            this.data[location][dataKey] = r.data.length > 0 ? r.data : this.data[location][dataKey]
            this.$emit('input', this.data)
          });
        }
        getData('/getTopCigSales', 'topCigSales')
      })
    },    
    saveEdit: function(location, row){
      // let updateData = {JSON: JSON.stringify(row.JSON)}
      // this.$axios.put(`/api/${location}/inventoryJson/${row.ItemNum}`, updateData).then((r)=>{
        // if (r.data[0] !== 1) row.JSON.price = ''
      // });
    },
    findDataRowIndex: function(location, ItemNum){
      let index;
      this.data[location].topCigSales.forEach((r,i)=> {if(r.ItemNum === ItemNum) index = i})
      // let dataRow = this.data[location].topCigSales.filter(r => r.ItemNum = ItemNum);
      // dataRow = dataRow.length > 0 ? dataRow[0] : undefined;
      // return dataRow
      return index;
    },
    saveEdit: async function(location, row, price){
      const dataRow = this.findDataRowIndex(location, row.ItemNum)
      price = price === undefined ? ((row.price) + (row.price * this.pst) + (row.price * this.gst)) : price;
      price = numeral(price).format("0,000.00")
      console.log(location, row.price, price, (row.price) + (row.price * this.pst) + (row.price * this.gst))
      const updateData = {JSON: JSON.stringify({...row.JSON, price})}
      const r = await this.$axios.put(`/api/${location}/inventoryJson/${row.ItemNum}`, updateData)
      if (r.data.length > 0 && r.data[0] === 1) this.$set(this.data[location].topCigSales[dataRow].JSON, 'price', price);;
    },
    propigatePrice: function(price){
      this.$locations.forEach(async location => {
        console.log(this.filteredData[location].topCigSales)
        this.filteredData[location].topCigSales.forEach(async row => {
          await this.saveEdit(location, row, price)
        })
      })
    },
    executePush: function(){
      const willPush = confirm(`Push to ${this.pushLocation}?`)
      if(!willPush) return;
      this.filteredData[this.pushLocation].topCigSales.forEach(async row => {
        const dataRow = this.findDataRowIndex(this.pushLocation, row.ItemNum)

        let price = numeral(row.JSON.price).value();
        // skip if the price is zero;
        if (Math.floor(price) === 0) return;

        const taxRate = Math.round((this.gst + this.pst) * 100)
        const taxes = price * taxRate / (100 + taxRate)
        price = numeral(price - taxes).format("0.000");
        
        console.log(row.JSON.price, price, row)
        
        let updateData = {Price: price}
        let r = await this.$axios.put(`/api/${this.pushLocation}/inventory/${row.ItemNum}`, updateData)
        console.log(r.data)
        // if (r.data.length > 0 && r.data[0] === 1) this.$set(this.data[location].topCigSales[dataRow].JSON, 'price', price);;

        if(row.carton_ItemNum !== null && row.carton_quantity !== null){
          updateData = {Price: price * row.carton_quantity}
          console.log(updateData)
          r = await this.$axios.put(`/api/${this.pushLocation}/inventory/${row.carton_ItemNum}`, updateData)
          console.log(r.data)
          // if (r.data.length > 0 && r.data[0] === 1) this.$set(this.data[location].topCigSales[dataRow].JSON, 'price', price);;
        }
        
        if(row.double_pack_ItemNum !== null && row.double_pack_quantity !== null){
          updateData = {Price: price * row.double_pack_quantity}
          console.log(updateData)
          r = await this.$axios.put(`/api/${this.pushLocation}/inventory/${row.double_pack_ItemNum}`, updateData)
          console.log(r.data)
          // if (r.data.length > 0 && r.data[0] === 1) this.$set(this.data[location].topCigSales[dataRow].JSON, 'price', price);;
        }
        
      })
      
    },
    roundedPrice: function(price){
      return parseFloat(numeral(price).format("0.00"))
    },
    priceAfterTax: function(price){
      return this.roundedPrice(price + (price * this.pst) + (price * this.gst))
    }
  },
  computed: {
    total: function(){
      return this.$math.sumSubSubKeys(this.filteredData);
    },
    filteredData: function(){
      const q = this.qualifier
      if(q.distributorFilter.length === 0 && q.includeFilter.length === 0 && q.excludeFilter.length === 0){
        return this.data
      } else {
        const result = {
          RCGB: {topCigSales:[]},
          RMGB: {topCigSales:[]},
          WGB : {topCigSales:[]},
        }
        this.$locations.forEach(location=>{
          result[location].topCigSales = this.data[location].topCigSales.filter(r=>{
            const itemName = r.ItemName.toLowerCase()
            const distributor = `${r.Distributor}`.toLowerCase()
            const distFilter = q.distributorFilter.toLowerCase()
            const inFilter = q.includeFilter.toLowerCase()
            const exFilter = q.excludeFilter.toLowerCase()
            const filterPackSize = this.filterPackSize === "All" ? true : this.filterPackSize === "25" ? !itemName.includes('20') : itemName.includes('20')
            const willFilter =  filterPackSize && (inFilter.length> 0 ? itemName.includes(inFilter) : true) && (exFilter.length> 0 ? !itemName.includes(exFilter) : true) && (distFilter.length> 0 ? distributor.includes(distFilter) : true);
            return willFilter;

          })
        })
        return result;
      }

    },

  },
  filters: {
    formatNumber: function(num, formatStyle="0,000.00"){
      return numeral(num === undefined ? 0 : num).format(formatStyle);
    },
  }
}
</script>


<style>
  input {
    line-height: 10px;
    height: 10px !important;
    margin: 0px 5px 0px 5px !important;
    border: 0px 1px 0px 1px !important;
  }
</style>

